module.exports = __webpack_public_path__ + "img/logo_es.20e65602.svg";